import { makeAutoObservable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'
import PPSlide from './Slide'

export default class PPSection {
    id = uuidv4()

    slide = []

    title = ''

    constructor(props) {
        if (Array.isArray(props.slide)) {
            this.slide = props.slide.map((s) => new PPSlide(s))
        }
        this.title = props.title ?? ''

        makeAutoObservable(this)
    }

    updateTitle(event) {
        this.title = event.value
    }

    addSlide = (slide, activeSlide, position) => {
        const ppSlide = slide instanceof PPSlide ? slide : new PPSlide(slide, this.store)
        if (position === 'above') {
            this.slide.splice(activeSlide, 0, ppSlide)
        } else {
            this.slide.splice(activeSlide + 1, 0, ppSlide)
        }
    }

    deleteSlide = (index) => {
        this.slide.splice(index, 1)
    }

    moveSlide = (from, to) => {
        const [slide] = this.slide.splice(from, 1)
        this.slide.splice(to, 0, slide)
    }

    toJSON = () => ({
        id: this.id,
        title: this.title,
        slide: this.slide.slice(),
    })
}
